import initTree from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/repository/index.js?vue3';
import { addShortcutsExtension } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/behaviors/shortcuts/index.js?vue3';
import ShortcutsNavigation from '~/behaviors/shortcuts/shortcuts_navigation';
import initAmbiguousRefModal from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/ref/init_ambiguous_ref_modal.js?vue3';

initTree();
initAmbiguousRefModal();
addShortcutsExtension(ShortcutsNavigation);
